export const CASH_REWARD_NUMBER = "200000";
export const CASH_REWARD_AS_SAP_NUMBER = "0000200000";
